import React, { Component } from "react";
import { Link } from "react-router";

import "./style.scss";

export default class SignUp extends Component {
  render() {
    const { selectPackage } = this.props;

    return (
      <div className="aboss__signup">
        <h1>Select your system</h1>

        <div className="aboss__signup-systems-container">
          <div className="aboss__signup-systems-container-item">
            <div className="aboss__signup-systems-artist">
              <h1>Artist</h1>
              <h2>For artist & team</h2>

              <ul>
                <li>Manage your calendar with events, notes & blocks</li>
                <li>Give access to your team with detailed permissions</li>
                <li>Label and filter all your events how you'd like</li>
                <li>Request the availability of crew members</li>
                <li>Keep track of your current cashflow</li>
              </ul>

              <div className="aboss__signup-systems-pricing">
                <strong>&nbsp;</strong>
                <span>
                  <span>&euro;</span>
                  <span>44</span>
                  <span>/ month</span>
                </span>
              </div>

              <div className="aboss__signup-systems-buttons">
                <Link to="/trial">
                  <button onClick={() => selectPackage("artist")}>
                    Sign up for ABOSS Artist
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <div className="aboss__signup-systems-container-spacer" />
          <div className="aboss__signup-systems-container-item">
            <div className="aboss__signup-systems-agency">
              <h1>Agency</h1>
              <h2>For agents & managers</h2>

              <ul>
                <li>Manage multiple calendars at the same time</li>
                <li>From request to contract in under 1 minute</li>
                <li>Shared contact database within the account</li>
                <li>Generate contracts & invoices based on your deals</li>
                <li>Track team member performance with the dashboard</li>
              </ul>

              <div className="aboss__signup-systems-pricing">
                <strong>Starting at</strong>
                <span>
                  <span>&euro;</span>
                  <span>131</span>
                  <span>/ month</span>
                </span>
              </div>

              <div className="aboss__signup-systems-buttons">
                <a href="#agency">
                  <button onClick={() => selectPackage("agency")}>
                    Sign up for ABOSS Agency
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/views/sign-up/step_1.js